import { Order, OrderSourceId } from "@/pages/Orders/orders.types";
import { itoOrderSource } from "./ito-order-source";
import { lcrOrderSource } from "./lcr-order-source";

export interface OrderSourceContext {
  hasPermission: (permission: string) => boolean;
}

export interface OrderSource {
  id: OrderSourceId;
  isEnabled: (context: OrderSourceContext) => boolean;
  fetch: (login: string) => Promise<Order[]>;
}

export const ORDER_SOURCES: OrderSource[] = [itoOrderSource, lcrOrderSource];
